import React, { SVGProps } from "react";

type ExtendedSVGProps = SVGProps<SVGSVGElement> & { color?: string };

const icons = {
  fig1: (props: ExtendedSVGProps) => (
    <svg viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M98.5714 14.6902L69.8571 0.132812H32.5714L0 32.0017V93.7722L87.4286 120.133L120 68.9853L98.5714 14.6902Z"
        fill={props.color || "#E16F60"}
      />
      <path
        d="M78.62 82.384V94H39.644V82.384H53.276V53.296C52.7 54.064 51.804 54.864 50.588 55.696C49.372 56.464 47.996 57.2 46.46 57.904C44.924 58.608 43.388 59.184 41.852 59.632C40.316 60.08 38.94 60.304 37.724 60.304V48.304C38.876 48.304 40.252 47.952 41.852 47.248C43.516 46.48 45.148 45.584 46.748 44.56C48.412 43.536 49.82 42.544 50.972 41.584C52.188 40.56 52.956 39.76 53.276 39.184H66.428V82.384H78.62Z"
        fill="white"
      />
    </svg>
  ),
  fig2: (props: ExtendedSVGProps) => (
    <svg viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M103.003 19.2963L44.5326 0.132812L22.0963 52.148H0L24.8159 111.007L81.9263 120.133L120 82.2621L99.6034 52.148L103.003 19.2963Z"
        fill={props.color || "#0C735A"}
      />
      <path
        d="M37.148 94C37.148 91.12 37.372 88.528 37.82 86.224C38.268 83.92 39.036 81.776 40.124 79.792C41.276 77.808 42.812 75.952 44.732 74.224C46.716 72.432 49.212 70.704 52.22 69.04C54.844 67.632 57.148 66.416 59.132 65.392C61.116 64.304 62.78 63.312 64.124 62.416C65.532 61.52 66.588 60.624 67.292 59.728C67.996 58.768 68.348 57.68 68.348 56.464C68.348 55.184 67.996 54.032 67.292 53.008C66.588 51.92 65.596 51.056 64.316 50.416C63.036 49.776 61.436 49.456 59.516 49.456C57.98 49.456 56.54 49.648 55.196 50.032C53.916 50.416 52.7 50.96 51.548 51.664C50.46 52.368 49.436 53.168 48.476 54.064C47.516 54.896 46.652 55.792 45.884 56.752L37.724 47.344C38.62 46.448 39.804 45.488 41.276 44.464C42.812 43.376 44.604 42.384 46.652 41.488C48.764 40.528 51.068 39.76 53.564 39.184C56.124 38.544 58.844 38.224 61.724 38.224C66.076 38.224 69.788 38.928 72.86 40.336C75.932 41.68 78.268 43.568 79.868 46C81.532 48.432 82.364 51.28 82.364 54.544C82.364 56.784 81.948 58.768 81.116 60.496C80.284 62.224 79.228 63.76 77.948 65.104C76.668 66.384 75.26 67.536 73.724 68.56C72.252 69.584 70.812 70.48 69.404 71.248C67.42 72.272 65.628 73.232 64.028 74.128C62.428 74.96 61.02 75.824 59.804 76.72C58.588 77.552 57.5 78.416 56.54 79.312C55.644 80.208 54.844 81.232 54.14 82.384H83.42V94H37.148Z"
        fill="white"
      />
    </svg>
  ),
  fig3: (props: ExtendedSVGProps) => (
    <svg viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.02909 49.9228L16.376 81.5292L0 98.1641L46.5093 120.133L111.902 108.227L101.433 85.4891L120 49.3695L83.3065 0.132812L22.8875 21.4144L4.02909 49.9228Z"
        fill={props.color || "#F6B89B"}
      />
      <path
        d="M70.076 71.344C72.764 71.792 75.1 72.816 77.084 74.416C79.068 75.952 80.604 77.936 81.692 80.368C82.844 82.8 83.42 85.488 83.42 88.432C83.42 92.4 82.396 95.856 80.348 98.8C78.3 101.744 75.388 104.016 71.612 105.616C67.9 107.28 63.516 108.112 58.46 108.112C53.596 108.112 49.276 107.312 45.5 105.712C41.788 104.176 38.684 101.904 36.188 98.896L43.484 89.776C45.148 91.824 47.132 93.424 49.436 94.576C51.804 95.792 54.684 96.4 58.076 96.4C61.98 96.4 64.956 95.6 67.004 94C69.052 92.464 70.076 90.128 70.076 86.992C70.076 83.664 68.892 81.104 66.524 79.312C64.156 77.52 60.572 76.624 55.772 76.624H53.084V67.024H56.06C59.964 67.024 63.004 66.128 65.18 64.336C67.42 62.544 68.54 60.304 68.54 57.616C68.54 55.888 68.124 54.448 67.292 53.296C66.46 52.144 65.308 51.28 63.836 50.704C62.428 50.128 60.764 49.84 58.844 49.84C55.964 49.84 53.34 50.512 50.972 51.856C48.604 53.2 46.684 55.088 45.212 57.52L37.148 48.496C38.492 46.512 40.316 44.816 42.62 43.408C44.988 41.936 47.676 40.784 50.684 39.952C53.756 39.12 56.956 38.704 60.284 38.704C64.636 38.704 68.444 39.408 71.708 40.816C75.036 42.224 77.628 44.208 79.484 46.768C81.34 49.328 82.268 52.304 82.268 55.696C82.268 58.192 81.756 60.56 80.732 62.8C79.708 65.04 78.268 66.928 76.412 68.464C74.62 69.936 72.508 70.896 70.076 71.344Z"
        fill="white"
      />
    </svg>
  ),
  fig4: (props: ExtendedSVGProps) => (
    <svg
      width="160"
      height="360"
      viewBox="0 0 160 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M103.486 118.311L195.571 -11.8506C201.225 -19.8415 213.687 -17.2454 215.68 -7.66183L359.973 686.345C361.232 692.401 357.344 698.331 351.288 699.59L203.95 730.224C198.818 731.291 193.632 728.655 191.469 723.88L95.1944 511.399L1.86791 304.276C-0.428889 299.179 1.38525 293.168 6.11866 290.193L114.027 222.361C117.989 219.871 119.985 215.18 119.032 210.599L101.663 127.059C101.031 124.016 101.691 120.848 103.486 118.311Z"
        fill={props.color || "#FADACC"}
      />
    </svg>
  ),
  fig5: (props: ExtendedSVGProps) => (
    <svg
      width="513"
      height="87"
      viewBox="0 0 513 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M179.45 -95.8059L1.8868 -22.8152C-0.646632 -21.7738 0.184023 -17.9921 2.92069 -18.1083C3.3599 -18.1269 3.796 -18.0269 4.18317 -17.8187L196.607 85.6654C198.763 86.8247 201.303 87.0386 203.623 86.2559L512.985 -18.1374L371.972 -41.9158L179.45 -95.8059Z"
        fill={props.color || "#0E8668"}
      />
      <path
        d="M194.775 45.112C194.775 46.2213 194.497 47.224 193.943 48.12C193.409 48.9947 192.673 49.6987 191.735 50.232C190.817 50.744 189.793 51 188.663 51H178.039V28.28H188.631C189.697 28.28 190.615 28.568 191.383 29.144C192.172 29.6987 192.769 30.424 193.175 31.32C193.601 32.1947 193.815 33.112 193.815 34.072C193.815 35.2027 193.527 36.2587 192.951 37.24C192.375 38.2 191.575 38.904 190.551 39.352C191.852 39.736 192.876 40.4613 193.623 41.528C194.391 42.5733 194.775 43.768 194.775 45.112ZM193.142 44.888C193.142 44.0773 192.951 43.32 192.567 42.616C192.204 41.912 191.703 41.336 191.062 40.888C190.423 40.44 189.697 40.216 188.887 40.216H179.671V49.528H188.663C189.495 49.528 190.252 49.3147 190.935 48.888C191.617 48.44 192.15 47.864 192.535 47.16C192.94 46.4347 193.142 45.6773 193.142 44.888ZM179.671 29.752V38.84H187.991C188.823 38.84 189.548 38.6267 190.167 38.2C190.807 37.752 191.308 37.1867 191.671 36.504C192.033 35.8 192.215 35.064 192.215 34.296C192.215 33.464 192.044 32.7067 191.703 32.024C191.361 31.3413 190.881 30.7973 190.263 30.392C189.665 29.9653 188.972 29.752 188.183 29.752H179.671ZM208.378 51.16C206.565 51.16 205.05 50.84 203.834 50.2C202.618 49.56 201.647 48.696 200.922 47.608C200.197 46.4987 199.674 45.2613 199.354 43.896C199.034 42.5307 198.874 41.1333 198.874 39.704V28.28H200.506V39.704C200.506 40.9413 200.634 42.1573 200.89 43.352C201.146 44.5467 201.562 45.624 202.138 46.584C202.735 47.5227 203.535 48.2693 204.538 48.824C205.562 49.3787 206.831 49.656 208.346 49.656C209.882 49.656 211.151 49.368 212.154 48.792C213.178 48.216 213.978 47.4587 214.554 46.52C215.151 45.56 215.567 44.4933 215.802 43.32C216.058 42.1253 216.186 40.92 216.186 39.704V28.28H217.818V39.704C217.818 41.2187 217.647 42.6693 217.306 44.056C216.986 45.4213 216.453 46.6373 215.706 47.704C214.959 48.7707 213.989 49.6133 212.794 50.232C211.599 50.8507 210.127 51.16 208.378 51.16ZM223.414 51V28.28H232.758C233.718 28.28 234.592 28.4827 235.382 28.888C236.192 29.2933 236.896 29.8373 237.494 30.52C238.091 31.1813 238.55 31.928 238.87 32.76C239.211 33.592 239.382 34.4453 239.382 35.32C239.382 36.536 239.104 37.688 238.55 38.776C238.016 39.8427 237.27 40.7173 236.31 41.4C235.371 42.0827 234.251 42.424 232.95 42.424H225.046V51H223.414ZM225.046 40.92H232.886C233.888 40.92 234.752 40.6533 235.478 40.12C236.203 39.5867 236.758 38.8933 237.142 38.04C237.526 37.1867 237.718 36.28 237.718 35.32C237.718 34.3173 237.483 33.4 237.014 32.568C236.566 31.7147 235.958 31.032 235.19 30.52C234.443 30.008 233.611 29.752 232.694 29.752H225.046V40.92ZM242.809 51V34.36H244.409V51H242.809ZM242.809 30.584V27.64H244.409V30.584H242.809Z"
        fill="white"
      />
    </svg>
  ),
  fig6: (props: ExtendedSVGProps) => (
    <svg
      width="160"
      height="79"
      viewBox="0 0 160 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.4557 58.0541L3.54937 92.2978C-3.12342 99.4594 1.95518 111.133 11.7437 111.133L278.6 111.133C284.786 111.133 289.8 106.118 289.8 99.9328V50.5837C289.8 45.3416 286.164 40.8009 281.049 39.6547L193.51 20.0395L108.809 1.24559C103.35 0.034504 97.8351 3.03413 95.8855 8.27412L81.4046 47.1947C79.7729 51.5802 75.5868 54.4891 70.9076 54.4891H43.65C40.5422 54.4891 37.5742 55.7804 35.4557 58.0541Z"
        fill={props.color || "#BFD9C8"}
      />
    </svg>
  ),
  fig7: (props: ExtendedSVGProps) => (
    <svg
      width="149"
      height="146"
      viewBox="0 0 149 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.315 -22.3515L2.03354 78.356C0.210779 81.1679 0.333683 84.8179 2.34148 87.5008L43.1705 142.059C44.9793 144.476 47.9948 145.669 50.9676 145.143L239.392 111.846C243.214 111.171 246 107.85 246 103.968V45.5087C246 43.9422 245.54 42.4102 244.677 41.1027L202.771 -22.406C201.291 -24.6498 198.782 -26 196.094 -26H74.0279C71.3166 -26 68.7898 -24.6267 67.315 -22.3515Z"
        fill={props.color || "#E16F60"}
      />
    </svg>
  ),
  fig8: (props: ExtendedSVGProps) => (
    <svg
      width="153"
      height="43"
      viewBox="0 0 153 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-28.6745 41.0867L-51.4647 65.5464C-56.231 70.6619 -52.6034 79 -45.6116 79L145 79C149.418 79 153 75.4183 153 71V35.7506C153 32.0063 150.403 28.7629 146.749 27.9442L84.2211 13.9333L23.7204 0.509128C19.8217 -0.355935 15.8822 1.78666 14.4896 5.52951L4.14615 33.3299C2.98066 36.4624 -0.00939941 38.5402 -3.3517 38.5402H-22.8214C-25.0413 38.5402 -27.1613 39.4626 -28.6745 41.0867Z"
        fill={props.color || "#FADACC"}
      />
    </svg>
  ),
  fig9: (props: ExtendedSVGProps) => (
    <svg
      width="206"
      height="39"
      viewBox="0 0 206 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.2101 18.7171L4.75234 32.501C-1.61752 35.3838 -1.48458 44.4759 4.96684 47.1711L180.846 120.65C184.923 122.353 189.609 120.429 191.312 116.352L204.9 83.8271C206.344 80.3722 205.198 76.3783 202.142 74.2145L149.848 37.1825L99.1978 1.47345C95.9339 -0.827666 91.4729 -0.369311 88.7452 2.54744L68.4843 24.2119C66.2014 26.653 62.6414 27.4176 59.5574 26.1292L41.5925 18.6238C39.5442 17.7681 37.2325 17.8019 35.2101 18.7171Z"
        fill={props.color || "#BFD9C8"}
      />
    </svg>
  ),
  fig10: (props: ExtendedSVGProps) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 73 165"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 72.0612L10.6458 0L73 7.16819V165L47.9062 137.388L39.5417 86.2041L0 72.0612Z"
        fill={props.color || "#FDEEE8"}
      />
    </svg>
  ),
  fig11: (props: ExtendedSVGProps) => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 225 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M103.954 -50.4116L1.5894 -8.33282C-0.0531579 -7.65762 0.429689 -5.21302 2.20561 -5.21303C2.44683 -5.21303 2.68502 -5.15918 2.90278 -5.05542L59.8247 22.067C61.3033 22.7716 62.9486 23.0516 64.577 22.8758L225.309 5.52787L218.739 -10.4546L103.954 -50.4116Z"
        fill={props.color || "#0E8668"}
      />
    </svg>
  ),
  fig12: (props: ExtendedSVGProps) => (
    <svg
      width="129"
      height="78"
      viewBox="0 0 129 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M133.247 156.063L0.046875 157.82L54.4673 119.548L65.4769 68.2739L131.2 0.894307L133.247 156.063Z"
        fill={props.color || "#0E8668"}
      />
    </svg>
  ),
  fig13: (props: ExtendedSVGProps) => (
    <svg
      width="386"
      height="50"
      viewBox="0 0 386 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M177.387 0.32549L2.00299 72.4204C-0.811257 73.5773 0.0160135 77.7657 3.05876 77.7657C3.47205 77.7657 3.88013 77.8579 4.25323 78.0357L103.393 125.274C104.871 125.979 106.516 126.259 108.145 126.083L385.308 96.1684L374.051 68.7852L177.387 0.32549Z"
        fill={props.color || "#FEF8F6"}
      />
    </svg>
  ),
  fig14: (props: ExtendedSVGProps) => (
    <svg
      width="384"
      height="108"
      viewBox="0 0 384 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M65.5443 89.6214L3.53148 156.233C-3.1368 163.396 1.94272 175.064 11.729 175.064L451.8 175.064C457.986 175.064 463 170.05 463 163.864V74.7895C463 69.5482 459.365 65.0079 454.251 63.861L311.813 31.9178L173.399 1.17988C167.939 -0.0325882 162.421 2.96854 160.473 8.21086L134.247 78.7556C132.617 83.1426 128.43 86.053 123.749 86.053H73.7418C70.6324 86.053 67.663 87.3456 65.5443 89.6214Z"
        fill={props.color || "#CFE5E0"}
      />
    </svg>
  ),
  fig15: (props: ExtendedSVGProps) => (
    <svg
      width="154"
      height="99"
      viewBox="0 0 154 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.4557 57.9213L3.54937 92.165C-3.12342 99.3266 1.95518 111 11.7437 111L278.6 111C284.786 111 289.8 105.986 289.8 99.8V50.4509C289.8 45.2088 286.164 40.668 281.049 39.5219L193.51 19.9067L108.809 1.11278C103.35 -0.0983085 97.8351 2.90132 95.8855 8.14131L81.4046 47.0619C79.7729 51.4474 75.5868 54.3563 70.9076 54.3563H43.65C40.5422 54.3563 37.5742 55.6476 35.4557 57.9213Z"
        fill={props.color || "#CFE5E0"}
      />
    </svg>
  ),
  fig16: (props: ExtendedSVGProps) => (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.5714 14.5574L69.8571 0H32.5714L0 31.8689V93.6393L87.4286 120L120 68.8525L98.5714 14.5574Z"
        fill={props.color || "#E16F60"}
      />
    </svg>
  ),
  fig17: (props: ExtendedSVGProps) => (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M103.003 19.1635L44.5326 0L22.0963 52.0152H0L24.8159 110.875L81.9263 120L120 82.1293L99.6034 52.0152L103.003 19.1635Z"
        fill={props.color || "#0C735A"}
      />
    </svg>
  ),
  fig18: (props: ExtendedSVGProps) => (
    <svg
      width="120"
      height="121"
      viewBox="0 0 120 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.02909 49.9228L16.376 81.5292L0 98.1641L46.5093 120.133L111.902 108.227L101.433 85.4891L120 49.3695L83.3065 0.132812L22.8875 21.4144L4.02909 49.9228Z"
        fill={props.color || "#E16F60"}
      />
    </svg>
  ),
  fig19: (props: ExtendedSVGProps) => (
    <svg
      width="294"
      height="324"
      viewBox="0 0 294 324"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.8294 217.862L1.18952 399.993C-1.75451 407.92 4.81205 416.125 13.1919 414.991L738.948 316.707C744.93 315.897 749.194 310.491 748.588 304.484L709.842 -79.5926C709.189 -86.0693 703.171 -90.6265 696.759 -89.4992L435.188 -43.507L177.441 2.36687C171.937 3.34654 167.998 8.23549 168.212 13.8223L173.902 162.357C174.081 167.033 171.335 171.327 167.015 173.126L75.0243 211.422C72.1552 212.616 69.9114 214.949 68.8294 217.862Z"
        fill={props.color || "#BFD9C8"}
      />
    </svg>
  ),
  fig20: (props: ExtendedSVGProps) => (
    <svg
      width="212"
      height="216"
      viewBox="0 0 212 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M211.72 117.875L120.998 73.6174L92.9519 0.381254L-32.503 3.84374L-56.4607 140.085L-112.771 197.955L-31.9452 316.178L177.957 281.664L211.72 117.875Z"
        fill={props.color || "#F6B89B"}
      />
    </svg>
  ),
  "arrow-down": (props: ExtendedSVGProps) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.00003 8.5C5.59557 8.5 5.23093 8.74364 5.07615 9.11732C4.92137 9.49099 5.00692 9.92111 5.29292 10.2071L11.2929 16.2071C11.6834 16.5976 12.3166 16.5976 12.7071 16.2071L18.7071 10.2071C18.9931 9.92111 19.0787 9.49099 18.9239 9.11732C18.7691 8.74364 18.4045 8.5 18 8.5H6.00003Z"
        fill="#2B363C"
      />
    </svg>
  ),
};

export type IconProps = {
  name: keyof typeof icons;
  color?: string;
} & SVGProps<SVGSVGElement>;

const Icon = ({ name, color, ...props }: IconProps) => {
  const Component = icons[name];
  return <Component color={color} {...props} />;
};

export default Icon;
